// src/reducers/cartReducers.js
import {
  CART_CLEAR_ITEMS,
  CART_REMOVE_ITEM,
  CART_SAVE_PAYMENT_METHOD,
  CART_SAVE_SHIPPING_ADDRESS,
  CART_UPDATE_ITEMS, // C'est cette constante qui est utilisée
} from '../constants/cartConstants';

// Harmonisation de la clé pour matcher les actions
const itemKeyOf = (item) => {
  const id = item.product?._id || item.product || item._id || '';
  const size = item.size || '';
  const color = item.color || '';
  return `${id}|${size}|${color}`;
};

const getLocalCart = () => {
  try {
    const raw = localStorage.getItem('cartItems');
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
};

const getLocalShipping = () => {
  try {
    const raw = localStorage.getItem('shippingAddress');
    return raw ? JSON.parse(raw) : { gpsCoordinates: { latitude: null, longitude: null } };
  } catch { return { gpsCoordinates: { latitude: null, longitude: null } }; }
};

const getLocalPayment = () => {
  try {
    const raw = localStorage.getItem('paymentMethod');
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

const initialState = {
  cartItems: getLocalCart(),
  shippingAddress: getLocalShipping(),
  paymentMethod: getLocalPayment(),
};

export const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    // Changement important : on s'assure que le payload est traité correctement
    case CART_UPDATE_ITEMS:
      return {
        ...state,
        cartItems: [...action.payload], // On crée une nouvelle référence de tableau
      };

    case CART_REMOVE_ITEM:
      return {
        ...state,
        cartItems: state.cartItems.filter(
          (ci) => itemKeyOf(ci) !== action.payload
        ),
      };
// Dans ton switch de cartReducer.js
case "CART_INC_QTY_SAFE": {
  const { key, max } = action.payload;

  return {
    ...state,
    cartItems: state.cartItems.map(it => {
      // On génère la clé de l'item actuel pour comparer
      const currentItemKey = `${it.product?._id || it.product}|${it.size ?? ""}|${it.color ?? ""}`;
      
      if (currentItemKey !== key) return it;

      // Priorité au stock réel de l'objet, sinon celui passé en payload, sinon illimité (999)
      const rawLimit = it.stockAtAdd ?? max;
      const limit = (rawLimit !== null && rawLimit !== undefined) ? Number(rawLimit) : 999;

      return {
        ...it,
        qty: Math.min(it.qty + 1, limit),
      };
    }),
  };
}

    case CART_SAVE_SHIPPING_ADDRESS:
      return { ...state, shippingAddress: action.payload };

    case CART_SAVE_PAYMENT_METHOD:
      return { ...state, paymentMethod: action.payload };

    case CART_CLEAR_ITEMS:
      return { ...state, cartItems: [] };
case 'CART_ADD_ITEM': {
  const item = action.payload;

  // ⛔ INTERDIT D’AJOUTER qty = 0
  if (!item.qty || item.qty < 1) {
    return state;
  }

  const existItem = state.cartItems.find(
    (x) =>
      x.product === item.product &&
      x.size === item.size &&
      x.color === item.color
  );

  if (existItem) {
    return {
      ...state,
      cartItems: state.cartItems.map((x) =>
        x.product === existItem.product &&
        x.size === existItem.size &&
        x.color === existItem.color
          ? {
              ...x,
              qty: Math.max(1, x.qty + item.qty),
              stockAtAdd: item.stockAtAdd ?? x.stockAtAdd,
            }
          : x
      ),
    };
  }

  return {
    ...state,
    cartItems: [...state.cartItems, item],
  };
}


    default:
      return state;
  }
};

